import styled from 'styled-components';

export default styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 0 1.34625rem;

  svg {
    margin-top: 0.375rem;
    margin-right: 0.375rem;
    height: 24px;
    width: 24px;
  }

  a {
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.claytonBlue};
    font-family: ${props => props.theme.fonts.secondary};
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 27px; /* 112.5% */
    text-decoration: underline;
  }
`;
